export const processServiceEvents = (serviceData: any) => {
    if (!serviceData || !Array.isArray(serviceData)) {
        return [];
    }
    return serviceData.flatMap(
        (serviceItemGroup: any) =>
            Array.isArray(serviceItemGroup.data) ? serviceItemGroup.data.map((event: any) => ({
                ...event,
                dateServicedTime: new Date(event.dateServiced).getTime()
            })) : []
    ).filter(event => event && event.dateServicedTime && !isNaN(event.dateServicedTime));
};

export const groupServiceEventsByTimestamp = (allServiceEvents: any[], zoomedChartData: any[]) => {
    if (zoomedChartData.length === 0 || !zoomedChartData[0]?.timestamp || !zoomedChartData[zoomedChartData.length - 1]?.timestamp) {
        return new Map();
    }
    const minTime = zoomedChartData[0].timestamp;
    const maxTime = zoomedChartData[zoomedChartData.length - 1].timestamp;

    const filteredEvents = allServiceEvents.filter(event =>
        event.dateServicedTime >= minTime && event.dateServicedTime <= maxTime
    );

    const grouped = new Map<number, typeof filteredEvents>();
    filteredEvents.forEach(event => {
        const timestamp = event.dateServicedTime;
        if (!grouped.has(timestamp)) {
            grouped.set(timestamp, []);
        }
        grouped.get(timestamp)!.push(event);
    });

    return grouped;
};